import { defineStore } from 'pinia'

export const useTableStore = defineStore('table', {
  state: () => ({
    pointsList: null,
    isLoadingDataSheets: false,
    selectValue: null,
    isLoading: true
  }),
  actions: {
    SET_STATE_FIELD(module, value) {
      this[module] = value
    }
  }
})
